import {sector} from 'constants/url';
import useAdd from 'components/hooks/useAdd';
import {AddingOptions} from 'components/grid-dx/types';

function useAddSector() {
  const addSector = useAdd(sector);
  return (addingOptions: AddingOptions) => addSector(addingOptions);
}

export default useAddSector;
